export default __webpack_public_path__ + "static/media/mockup-step-1.677c01ff.png";